import API from "@/models/API";

export default class UserRights {
    constructor(item = {}) {
        this.user_id = item.user_id || null;
        this.mobile = item.mobile || "";
        this.user = item.user || "";
        this.password = item.password || "";
        this.permissions = item.permissions || {};
        this.role_id = item.role_id || null;
        this.user_account_id = item.user_account_id || null;

    }

    static get = (query) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/users${query}`);

    
    
    static create = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/users`,
            item
        );

    static update = item =>
        API.put(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/users/${item.user_id}/permissions`,
            item
        );

    static getDefaultPermissions = () =>
        API.get(
            `/users/default-permissions`
        );

        static upgrade = id =>
            API.put(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/users/upgrade/${id}`
            );
            

            static downgrade = id =>
            API.put(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/users/downgrade/${id}`
            );
            

            static delete = id =>
            API.delete(
                `/companies/${localStorage.getItem(
                    "storeId"
                )}/users/${id}`
            );
            
        static getRoles = () =>
        API.get(`/common/roles`);
}
